// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3116DhFJcebpVrdPvXNxNc{border-left:.1rem solid #e0e0e0;display:block;padding:.8rem 1.2rem;transition:all .2s ease-in}._3116DhFJcebpVrdPvXNxNc:focus,._3116DhFJcebpVrdPvXNxNc:hover{-webkit-text-decoration:none;text-decoration:none}._3116DhFJcebpVrdPvXNxNc.usy78KbGINtIMsmFma6rJ{border-left:.2rem solid #202020;color:#202020;padding-left:1.1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": "_3116DhFJcebpVrdPvXNxNc",
	"active": "usy78KbGINtIMsmFma6rJ"
};
module.exports = ___CSS_LOADER_EXPORT___;
